import React from "react";
import styled from "styled-components";
import {loaderanimationRule} from "../../../CommonContentLoaderStyled/widgets/Styled";
import {GreyContent} from "../../../../theme/variable";

export const CheckBoxLoaderWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;
`;
export const CheckBoxLoaderDiv = styled.div`
    width: 100%;
    &:before {
        content: "";
        border: 1.5px solid ${GreyContent};
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
    }
    > div {
        background: ${GreyContent};
        width: 60px;
        height: 16px;
        animation: ${loaderanimationRule};
        display: inline-block;
        margin-left: 5px;
        vertical-align: middle;
    }
`;
export const CheckBoxLoader = () => {
    return (
        <React.Fragment>
            <CheckBoxLoaderWrapper>
                {[1, 2, 3].map((index) => {
                    return (
                        <CheckBoxLoaderDiv key={index}>
                            <div />
                        </CheckBoxLoaderDiv>
                    );
                })}
            </CheckBoxLoaderWrapper>
        </React.Fragment>
    );
};
export default CheckBoxLoader();
